import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React, {ComponentProps} from 'react';
import {DialogRegistration} from '../model/DialogRegistration';

const typeMap = {error: 'alert', success: 'check', warning: 'attention'} as const;

export function InfoPopup({type, title, details, actions, placement, onClose, onExitEnd}: InfoPopup.Props) {
    const controls = RsnDialog.useControls();
    actions ??= {secondary: ['I got it', () => (controls.onClose?.(), onClose?.())]};
    return (
        <RsnDialog.Window placement={placement} onExitEnd={onExitEnd}>
            <RsnDialog.CenteredHeader icon={type && {element: <RsnDialog.StatusIcon status={typeMap[type]} />}}>
                {title}
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>{details}</RsnDialog.Body>
            <RsnDialog.Footer column>
                {actions.primary && (
                    <RsnButton.Primary onClick={actions.primary[1]}>{actions.primary[0]}</RsnButton.Primary>
                )}
                {actions.secondary && (
                    <RsnButton.Secondary onClick={actions.secondary[1]}>{actions.secondary[0]}</RsnButton.Secondary>
                )}
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}

export namespace InfoPopup {
    export interface Props {
        type?: keyof typeof typeMap;
        title: string;
        details: string;
        actions?: {
            primary?: [string, () => void];
            secondary?: [string, () => void];
        };
        placement?: ComponentProps<typeof RsnDialog.Window>['placement'];
        onClose?: () => void;
        onExitEnd?: () => void;
    }
}

export const AddressV10nPendingInfo = DialogRegistration.create({
    name: 'AddressV10nPendingInfo',
    Component: () => (
        <InfoPopup
            title='Address verification is pending'
            details='We will inform you about the availability of the functionality as soon as your documents are verified.'
        />
    ),
});
